<template>
  <div class="property_wrap">
    <div class="pro_top">单行文本</div>
    <div class="pro_con">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="类型:">
          <el-radio-group v-model="property.radio"  @change="changetype">
            <el-radio :label="1">手机号</el-radio>
            <el-radio :label="2">姓名</el-radio>
            <el-radio :label="3">邮箱</el-radio>
            <el-radio :label="4">自定义文本</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="提示语:">
          <el-input v-model="property.name" maxlength="6" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="字数限制:" v-if="property.radio!==3">
          <el-input v-model="property.num" type="number" maxlength="11">
            <template slot="append">字</template>
          </el-input>
        </el-form-item>
        <el-form-item label="验证码:" v-if="property.radio==1">
         <el-radio-group v-model="property.radio2">
            <el-radio :label="1">需要验证手机号</el-radio>
            <el-radio :label="2">不需要验证手机号</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="property.checked">设为必填项</el-checkbox>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  props: ["property"],
  data() {
    return {
      form: {
        
      }
    };
  },
  methods:{
    changetype:function(e){
      if(e==1){
        this.property.name="手机号";
        this.property.num=15
      }else if(e==2){
        this.property.name="姓名";
        this.property.num=11
      }else if(e==3){
        this.property.name="邮箱"
      }else if(e==4){
        this.property.name="自定义文本";
        this.property.num=15
      }
    }
  }
};
</script>

 